import React, {Component} from 'react';
import './css/loader.css';
import $ from 'jquery';
import ReactDOM from 'react-dom';

class PageLoader extends Component {
    getThisEl() {
        return ReactDOM.findDOMNode(this);
    }

    // componentWillMount() {
    //     console.log('loader component mounting...');
    //     console.log(this.getDOMNode());
    //     // $(this.getDOMNode()).fadeIn();
    // }

    componentDidMount() {
        console.log('loader component did mount...');
        // console.log();
        // $(this.getThisEl()).fadeIn();
        $(this.getThisEl()).stop(true).hide().fadeIn();
    }

    componentWillUnmount() {
        // console.log('loader component unmounting...');
        // $(this.getThisEl()).fadeOut(function () {
        //
        // });
    }

    render() {
        return (
            <div className="loader"></div>
        );
    }
}

export default PageLoader;


// WEBPACK FOOTER //
// ./src/components/loader.js